<template>
    <div class="coming-soon">
  <h1>Coming Soon</h1>
    </div>
           
           
   </template>
   <script>

   export default {
  
       components: {
         
       },
       props:{
      
       },
       data: function () {
           return { 
            
           };
       },
       methods: {
       
       }
   };
   
   </script>
   <style>
.coming-soon{
      display: flex
;
    justify-content: center;
    flex-direction: row;
    width: 1000px;
    align-items: center;
    height: 400px;
    font-size:100px

}

</style>